import React, { useState, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import DummyOutput from './DummyOutput'
import { TabPanel, TabProvider, TabButton } from '@tecuity/granite-ui'

const GenericDummyDetails = () => {
  const [activeTabId, setActiveTabId] = useState('tab-0')
  const { recordDetailConfig } = useSelector((state) => state.settings)
  const {
    Tabs = [],
    DetailCards = [],
    FieldSettings = {},
    HistoryConfig = [],
  } = recordDetailConfig.sourceTypeConfig &&
  recordDetailConfig.sourceTypeConfig[recordDetailConfig.subType]
    ? recordDetailConfig.sourceTypeConfig[recordDetailConfig.subType]
    : recordDetailConfig.sourceTypeConfig || {}

  const getHistoryOutput = (type) => {
    switch (type) {
      case 'dln':
        return 'B1234-1234'
      case 'receiptNum':
        return '01234567'
      case 'amount':
        return '$9.95'
      case 'voidButton':
        return '(button)'
      default:
        return 'String'
    }
  }

  const handleTabChange = (tabId) => {
    setActiveTabId(tabId)
  }

  return (
    <TabProvider activeTabId={activeTabId} onChange={(id) => handleTabChange(id)}>
      <div className="row header-row">
        <div className="tablist" role="tablist">
          {(Tabs || []).map(
            (tab, i) =>
              tab.Title !== 'Notes' &&
              (tab.Enabled || tab.IsEnabled) && (
                <TabButton
                  key={`tab-${i}`}
                  id={`tab-${i}`}
                  forPanelId={`panel-${i}`}
                  label={tab.Title}
                />
              )
          )}
        </div>
      </div>
      <div
        className="row"
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '20px',
          marginBottom: '20px',
          justifyContent: 'space-evenly',
        }}
      >
        {(Tabs || []).map((tab, i) => (
          <TabPanel key={`tabpanel-${i}`} tabId={`tab-${i}`} id={`panel-${i}`}>
            <div
              className="row"
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '20px',
                marginBottom: '20px',
              }}
            >
              {DetailCards.sort((a, b) => (a.Order > b.Order ? 1 : -1)).map((card) => {
                return (
                  card.Tab === i && (
                    <DummyDetailCard key={card.Title} card={card} fields={FieldSettings} />
                  )
                )
              })}
              {HistoryConfig && HistoryConfig.length > 0 && tab.Title === 'History' && (
                <DetailCard
                  className="historyDetailsCard"
                  label="History/Filing Config"
                  style={{ flexGrow: '1' }}
                >
                  <div className="dummy-card history">
                    <div className="dummy-card-col">
                      {HistoryConfig.map((field, i) => {
                        return (
                          <DummyOutput
                            key={`${field.id || field.Id}-${i}`}
                            accessor={field.id || field.Id}
                            info={field}
                            outputFormat={getHistoryOutput(field.type || field.Type)}
                            isHistory
                            isGeneric
                          />
                        )
                      })}
                    </div>
                  </div>
                </DetailCard>
              )}
            </div>
          </TabPanel>
        ))}
      </div>
    </TabProvider>
  )
}

const DummyDetailCard = ({ card = {}, fields = {}, ...props }) => {
  const getOutputFormat = (type) => {
    switch (type) {
      case 0:
        return 'String'
      case 2:
        return 'Address'
      case 4:
        return 'MM/dd/yyyy'
      case 16:
        return 'String'
      case 32:
        return 'Boolean'
      case 64:
        return 'Standing'
      case 128:
        return 'List'
      case 256:
        return '(Button)'
      case 512:
        return 'Image Viewer Link'
      case 1024:
        return 'Link'
      default:
        return 'Format Not Found'
    }
  }

  const fieldsInCard = useMemo(() => {
    const keys = Object.keys(fields)
    const fieldsInCard = []
    keys.forEach((key) => {
      if (!fields[key] && card.Order === 1) {
        fieldsInCard.push({
          // ...fields[key],
          CardNumber: 1,
          Column: 0,
          DisplayName: '',
          Type: 0,
          outputFormat: getOutputFormat(0),
          accessor: key,
        })
      } else if (fields[key] && fields[key].CardNumber === card.Order) {
        fieldsInCard.push({
          ...fields[key],
          outputFormat: getOutputFormat(fields[key].FieldType),
          accessor: key,
          ...(fields[key].Fields && {
            Fields: Object.entries(fields[key].Fields).map((field) => {
              return {
                [field[0]]: field[1],
              }
            }),
          }),
        })
      }
    })
    return fieldsInCard.sort((a, b) => (a.SortOrder > b.SortOrder ? -1 : 1))
  }, [fields, card])

  const columns = useMemo(() => {
    let columns = []
    for (let i = 0; i <= card.Columns; i++) {
      columns[i] = []
      fieldsInCard.forEach((field) => {
        if (field.Column === i) columns[i].push(field)
      })
    }
    return columns
  }, [card, fieldsInCard])

  return (
    <DetailCard className="detailsCard" label={card.Title} style={{ flexGrow: '1' }} {...props}>
      <div className="dummy-card">
        {columns.map((column, colIndex) => {
          return (
            <div className="dummy-card-col" key={colIndex}>
              {column.map((field, i) => {
                return Number(field.FieldType) === 128 ? (
                  <DetailCard
                    className='sub-card'
                    key={`${field.accessor}-${i}`}
                    label={`${field.DisplayName}`}
                    customCss={{ width: '100%' }}
                  >
                    {field.Fields.map((subfield, i) =>
                      Object.entries(subfield).map(([key, val]) => {
                        // console.log({ key, val })
                        return (
                          <React.Fragment key={`${key}-${i}`}>
                            <DummyOutput
                              key={`${key}-${i}`}
                              info={{
                                ...val,
                                outputFormat: val && val.FieldType ? val.FieldType : 0,
                                accessor: key,
                                CardNumber: 5,
                                Column: 0,
                              }}
                              outputFormat={getOutputFormat(
                                val && val.FieldType ? val.FieldType : 0
                              )}
                              accessor={key}
                              isGeneric
                            />
                          </React.Fragment>
                        )
                      })
                    )}
                  </DetailCard>
                ) : (
                  <React.Fragment key={`${field.accessor}-${i}`}>
                    <DummyOutput
                      key={`${field.accessor}-${i}`}
                      accessor={field.accessor}
                      info={field}
                      outputFormat={field.outputFormat}
                      isGeneric
                    />
                  </React.Fragment>
                )
              })}
            </div>
          )
        })}
      </div>
    </DetailCard>
  )
}

export default GenericDummyDetails

export const dummyTest = {
  0: {
    Title: 'Business',
    DetailCards: [
      {
        Order: 0,
        Columns: 1,
        Title: 'General Details',
        Enabled: true,
      },
      {
        Order: 1,
        Columns: 1,
        Title: 'Addresses',
        Enabled: true,
      },
      {
        Order: 2,
        Columns: 0,
        Title: 'Other',
        Enabled: true,
      },
      {
        Order: 4,
        Columns: 1,
        Title: 'Agent Details',
        Enabled: true,
      },
    ],
    FieldSettings: {
      Name: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'Name',
        FieldType: 0,
      },
      FileNum: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'File Number',
        FieldType: 0,
      },
      RecordType: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'Type',
        FieldType: 16,
      },
      RecordSubtype: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'Sub-Type',
        FieldType: 16,
      },
      TermOfDuration: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'Term of Duration',
        FieldType: 0,
      },
      Status: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'Status',
        FieldType: 0,
      },
      StandingAR: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'AR Standing',
        FieldType: 64,
      },
      StandingOther: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'Other Standing',
        FieldType: 64,
      },
      SeeNotesFlag: {
        CardNumber: 2,
        Column: 0,
        Enabled: true,
        DisplayName: 'See Notes Flag',
        FieldType: 32,
      },
      FormationState: {
        CardNumber: 2,
        Column: 0,
        Enabled: true,
        DisplayName: 'Formation State',
        FieldType: 0,
      },
      DateFormed: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'Date Formed',
        FieldType: 4,
      },
      InitialFilingDate: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'Initial Filing Date',
        FieldType: 0,
      },
      ExpirationDate: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'Expiration Date',
        FieldType: 4,
      },
      InactiveDate: {
        CardNumber: 0,
        Column: 0,
        Enabled: true,
        DisplayName: 'Inactive Date',
        FieldType: 4,
      },
      DelayedEffectiveDate: {
        CardNumber: 2,
        Column: 0,
        Enabled: true,
        DisplayName: 'Delayed Effective Date',
        FieldType: 0,
      },
      PrincipleAddress: {
        CardNumber: 1,
        Column: 0,
        Enabled: true,
        DisplayName: 'Principle Address',
        FieldType: 2,
      },
      MailingAddress: {
        CardNumber: 1,
        Column: 0,
        Enabled: true,
        DisplayName: 'Mailing Address',
        FieldType: 2,
      },
      RegisteredAgentName: {
        CardNumber: 4,
        Column: 0,
        Enabled: true,
        DisplayName: 'Agent Name',
        FieldType: 0,
      },
      RegisteredAgentNum: {
        CardNumber: 4,
        Column: 0,
        Enabled: true,
        DisplayName: 'Agent Num',
        FieldType: 0,
      },
      RegisteredAgentEntitiesCount: {
        CardNumber: 4,
        Column: 0,
        Enabled: true,
        DisplayName: 'Agent Entity Count',
        FieldType: 0,
      },
      RegisteredAgentAddress: {
        CardNumber: 4,
        Column: 0,
        Enabled: true,
        DisplayName: 'Registered Agent Address',
        FieldType: 0,
      },
    },
    HistoryConfig: [
      {
        enabled: true,
        staffField: true,
        label: 'Type',
        id: 'FilingType',
        type: '',
      },
      {
        enabled: true,
        staffField: true,
        label: 'Filing Number',
        id: 'FilingNumber',
        type: '',
      },
      {
        enabled: true,
        staffField: true,
        label: 'Filing Date',
        id: 'FilingDate',
        type: '',
      },
      {
        enabled: true,
        staffField: true,
        label: 'DLN',
        id: 'DLN',
        type: 'dln',
      },
      {
        enabled: true,
        staffField: true,
        label: 'Receipt Num',
        id: 'ReceiptNumber',
        type: 'receiptNum',
      },
      {
        enabled: true,
        staffField: true,
        label: 'Amount',
        id: 'ReceiptAmount',
        type: 'amount',
      },
      {
        enabled: true,
        staffField: true,
        label: 'Status',
        id: 'Status',
        type: '',
      },
      {
        enabled: true,
        staffField: true,
        label: 'Created By User',
        id: 'CreatedByUser',
        type: '',
      },
      {
        enabled: true,
        staffField: true,
        label: 'Last Modified By User',
        id: 'LastModifiedByUser',
        type: '',
      },
      {
        enabled: true,
        staffField: true,
        label: 'voidInfo',
        id: 'voidInfo',
        type: 'voidButton',
      },
    ],
  },
}
